import React from 'react';
import { Questionnaire } from '@dmm/lib-react-ui-components';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { syncTranslationElements } from '../../../tppServices/translations/intlManager';

const BDPQuestionnaire = (props) => {
  const intl = useIntl();
  const { messages, t } = syncTranslationElements(intl);
  const {
    breakpoint,
    handleCloseClick,
    handleDoneClick,
    handleSkipClick
   } = props;

const questions = [
  {
    type: 'single-choice',
    title: t(messages.questionnaire.singleChoiceQuestion.title),
    options: [
      t(messages.questionnaire.singleChoiceQuestion.option1),
      t(messages.questionnaire.singleChoiceQuestion.option2),
      t(messages.questionnaire.singleChoiceQuestion.option3),
      t(messages.questionnaire.singleChoiceQuestion.option4)
    ],
    name: 'singleChoiceQuestion'
  },
  {
    type: 'boolean',
    title: t(messages.questionnaire.booleanQuestion.title),
    options: [
      t(messages.questionnaire.booleanQuestion.option1),
      t(messages.questionnaire.booleanQuestion.option2)
    ],
    name: 'booleanQuestion'
  },
  {
    type: 'text',
    title: t(messages.questionnaire.textQuestion.title),
    placeholder: t(messages.questionnaire.textQuestion.placeholder),
    textLabel: t(messages.questionnaire.textQuestion.title),
    name: 'textQuestion'
  }
];

  return (
    <div
      data-testid="questionnaire"
      className={`questionnaire ${breakpoint === 'mobile' ? 'mobile-view' : ''}`}
    >
      <Questionnaire
        headerText={t(messages.questionnaire.headerText)}
        introText={t(messages.questionnaire.introText)}
        doneButtonText={t(messages.questionnaire.doneButtonText)}
        skipButtonText={t(messages.questionnaire.skipButtonText)}
        handleSkipClick={handleSkipClick}
        handleDoneClick={handleDoneClick}
        onClose={handleCloseClick}
        questions={questions}
        doneButtonAttributes={{ 'data-testing': 'questions-submitted' }}
        skipButtonAttributes={{ 'data-testing': 'questions-skipped' }}
      ></Questionnaire>
    </div>
  );
};

BDPQuestionnaire.propTypes = {
  breakpoint: PropTypes.string,
  handleCloseClick: PropTypes.func,
  handleDoneClick: PropTypes.func,
  handleSkipClick: PropTypes.func,
};

export default BDPQuestionnaire;
